import React from 'react';
import { X } from 'lucide-react';

// Master select-all bar + bulk actions bar (Wave 1s/1u7).
export default function EmailBulkBar({
  threads, folder, selectedThreadIds, nextPageToken,
  onSelectAll, onClearSelection, onBulk,
}) {
  if (threads.length === 0 || folder === 'DRAFT') return null;
  const count = selectedThreadIds.size;
  return (
    <>
      <div className="px-3 py-1.5 border-b border-[#EFF0F6] flex items-center gap-2 text-[11px] text-[#6B6C85]" data-testid="email-bulk-select-bar">
        <input
          type="checkbox"
          checked={count > 0 && count === threads.length}
          ref={(el) => { if (el) el.indeterminate = count > 0 && count < threads.length; }}
          onChange={() => { if (count === threads.length) onClearSelection(); else onSelectAll(); }}
          data-testid="email-bulk-select-all"
          title="Tout sélectionner / désélectionner"
          className="cursor-pointer"
        />
        <span className="font-semibold text-[#4A4B63]">
          {count === 0
            ? `${threads.length}${nextPageToken ? '+' : ''} message${threads.length > 1 ? 's' : ''}`
            : `${count} / ${threads.length} sélectionné${count > 1 ? 's' : ''}`}
        </span>
        {count > 0 && count < threads.length && (
          <button
            type="button"
            onClick={onSelectAll}
            data-testid="email-bulk-select-rest"
            className="text-[10.5px] underline text-[#4F46E5] hover:text-[#4338CA]"
          >
            Tout sélectionner ({threads.length})
          </button>
        )}
      </div>
      {count > 0 && (
        <div className="px-3 py-2 border-b border-[#EFF0F6] bg-[#EEF2FF] flex items-center justify-between gap-2" data-testid="email-bulk-bar">
          <div className="text-[12px] font-semibold text-[#4F46E5]">
            {count} sélectionné{count > 1 ? 's' : ''}
          </div>
          <div className="flex items-center gap-1.5 flex-wrap justify-end">
            <button onClick={() => onBulk('mark-read')} data-testid="email-bulk-read" className="h-7 px-2 rounded text-[11px] font-semibold bg-white border border-[#C7D2FE] text-[#4F46E5] hover:bg-[#EEF2FF]">Marquer lus</button>
            <button onClick={() => onBulk('mark-unread')} data-testid="email-bulk-unread" className="h-7 px-2 rounded text-[11px] font-semibold bg-white border border-[#C7D2FE] text-[#4F46E5] hover:bg-[#EEF2FF]">Non lus</button>
            <button onClick={() => onBulk('star')} data-testid="email-bulk-star" className="h-7 px-2 rounded text-[11px] font-semibold bg-white border border-[#FDE68A] text-[#92400E] hover:bg-[#FEF3C7]">★</button>
            <button onClick={() => onBulk('archive')} data-testid="email-bulk-archive" className="h-7 px-2 rounded text-[11px] font-semibold bg-white border border-[#EFF0F6] text-[#6B6C85] hover:bg-white">Archiver</button>
            {folder === 'SPAM' ? (
              <button onClick={() => onBulk('unspam')} data-testid="email-bulk-unspam" className="h-7 px-2 rounded text-[11px] font-semibold bg-white border border-[#FED7AA] text-[#9A3412] hover:bg-[#FFF7ED]">Non spam</button>
            ) : (
              <button onClick={() => onBulk('spam')} data-testid="email-bulk-spam" className="h-7 px-2 rounded text-[11px] font-semibold bg-white border border-[#FED7AA] text-[#9A3412] hover:bg-[#FFF7ED]">Spam</button>
            )}
            <button onClick={() => onBulk('trash')} data-testid="email-bulk-trash" className="h-7 px-2 rounded text-[11px] font-semibold bg-white border border-[#FCA5A5] text-[#B91C1C] hover:bg-[#FEF2F2]">Corbeille</button>
            <button onClick={onClearSelection} title="Tout désélectionner" className="h-7 w-7 rounded text-[#8E8FA5] hover:text-[#1A1B2E] flex items-center justify-center"><X className="w-3.5 h-3.5" /></button>
          </div>
        </div>
      )}
    </>
  );
}
